// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:d6eb8114-e6dc-4a7b-b46c-a80277b070e2',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_d8rjvgesg',
    aws_user_pools_web_client_id: '5i792arqe0t87tip8lp8uga4gq',
    oauth: {
        domain: 'betterspace-dev-stg.auth.eu-west-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
        ],
        redirectSignIn: 'https://stg-user.betterspace.uk/callback',
        redirectSignOut: 'https://stg-user.betterspace.uk/logout',
        responseType: 'token',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cloud_logic_custom: [
        {
            name: 'AdminQueries',
            endpoint: 'https://boqm2xctud.execute-api.eu-west-2.amazonaws.com/stg',
            region: 'eu-west-2',
        },
    ],
    aws_content_delivery_bucket: 'webapp-production-betterspace-stg',
    aws_content_delivery_bucket_region: 'eu-west-2',
    aws_content_delivery_url: 'https://dj8qze8vpkw4g.cloudfront.net',
}


export default awsmobile
